import { IData } from '../interface';

const render = (data: IData) => {
    if (!data.IS_PRODUCTION) {
        if (data.SYSTEM === '"CN"' || data.SYSTEM === 'CN') {
            return `
                <script src="https://cdn-go.cn/aegis/aegis-sdk/latest/aegis.min.js"></script>
                <script>
                    if (Aegis) {
                        var aegis = new Aegis({
                            id: 'jyD6daAokRv5AR4Wo1',
                            uin: 'umu-test', // 用户唯一 ID（可选）
                            reportApiSpeed: true, // 接口测速
                            reportAssetSpeed: true, // 静态资源测速
                            spa: true // spa 应用页面跳转的时候开启 pv 计算
                        });
                    }
                </script>
            `;
        }

        return '';
    }

    if (data.IS_PRODUCTION) {
        if (data.SYSTEM === '"CN"' || data.SYSTEM === 'CN') {
            return `
            <script src="https://cdn-go.cn/aegis/aegis-sdk/latest/aegis.min.js"></script>
            <script>
                if (Aegis) {
                    var aegis = new Aegis({
                        id: 'RZ9L5lAEPvq4BXWxmE',
                        uin: 'umu', // 用户唯一 ID（可选）
                        reportApiSpeed: true, // 接口测速
                        reportAssetSpeed: true, // 静态资源测速
                        spa: true // spa 应用页面跳转的时候开启 pv 计算
                    });
                }
            </script>
            `;
        }
    }

    return '';
};

export default render;
